export const CONTAINERS: string[] = [
	'dinf',
	'edts',
	'enca',
	'encv',
	'grpl',
	'mdia',
	'meco',
	'meta',
	'mfra',
	'minf',
	'moof',
	'moov',
	'mvex',
	'prsl',
	'schi',
	'sinf',
	'stbl',
	'strk',
	'traf',
	'trak',
	'tref',
	'udta',
	'vttc',
];
